<template>
  <component
    :is="type"
    :to="to"
    :disabled="disabled"
    class="text-neutral-500 transition-colors duration-150 ease-out-quart hover:text-neutral-400"
  >
    <font-awesome-icon :icon="icon" :size="size" />
  </component>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { RouteLocationRaw } from 'vue-router';

import type { FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';

interface Props {
  to?: RouteLocationRaw;
  icon: string[];
  size: FontAwesomeIconProps['size'];
  disabled?: boolean;
}

const props = defineProps<Props>();

const type = computed(() => {
  if (props.to) {
    return 'router-link';
  }

  return 'button';
});
</script>
